<template>
  <div class="space-between-row">
    <div class="v-datatable-light-pagination">
      <!-- <div v-if="moveFirstPage" class="pagination-item move-first-page">
        <button :disabled="isActionDisabled('firstPage')" class="page-btn" @click="changePage(1)">
          &lt;&lt;
        </button>
      </div> -->
      <div v-if="movePreviousPage" class="pagination-item move-previous-page">
        <button
          :disabled="isActionDisabled('previousPage')"
          class="page-btn"
          @click="changePage(currPage - 1)"
        >
          <i class="material-icons">keyboard_arrow_left</i>
        </button>
      </div>
      <div v-for="pageNr in qntPages" :key="pageNr" :class="pageClass(pageNr)">
        <template v-if="pageNr !== currPage">
          <button :disabled="disablePagination" class="page-btn" @click="changePage(pageNr)">
            {{ pageNr }}
          </button>
        </template>
        <template v-else>
          <button :disabled="disablePagination" class="page-btn-selected" @click="changePage(pageNr)">
            {{ pageNr }}
          </button>
        </template>
      </div>
      <div v-if="moveNextPage" class="pagination-item move-next-page">
        <button :disabled="isActionDisabled('nextPage')" class="page-btn" @click="changePage(currPage + 1)">
         <i class="material-icons">keyboard_arrow_right</i>
        </button>
      </div>
      <!-- <div v-if="moveLastPage" class="pagination-item move-last-page">
        <button :disabled="isActionDisabled('lastPage')" class="page-btn" @click="changePage(lastPage)">
          &gt;&gt;
        </button>
      </div> -->
    </div>
    <span>Total Items: {{ totalItems }}</span>
  </div>
</template>
<script>
export default {
  name: 'DataTablePagination',
  props: {
    totalItems: {
      type: Number,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    page: {
      type: Number,
      default: 1,
    },
    moveLastPage: {
      type: Boolean,
      default: true,
    },
    moveFirstPage: {
      type: Boolean,
      default: true,
    },
    moveNextPage: {
      type: Boolean,
      default: true,
    },
    movePreviousPage: {
      type: Boolean,
      default: true,
    },
    disablePagination: {
      type: Boolean,
      default: false,
    },
    css: {
      type: Object,
      default: () => ({
        paginationItem: 'pagination-item',
        moveFirstPage: 'move-first-page',
        movePreviousPage: 'move-previous-page',
        moveNextPage: 'move-next-page',
        moveLastPage: 'move-last-page',
        pageNumber: 'page-number',
        pageBtn: 'page-btn',
      }),
    },
  },
  data: function() {
    return {
      perPage: this.itemsPerPage,
      currPage: this.page,
    }
  },
  computed: {
    qntPages: function() {
      const nrPages = this.lastPage
      if (nrPages > 4) {
        if (this.currPage <= 3) {
          return Array.apply(null, { length: 5 }).map((_, index) => index + 1)
        } else if (this.currPage + 2 >= nrPages) {
          return Array.apply(null, { length: nrPages })
            .map((_, index) => index + 1)
            .slice(nrPages - 5, nrPages)
        } else {
          return Array.apply(null, { length: nrPages })
            .map((_, index) => index + 1)
            .slice(this.currPage - 3, this.currPage + 2)
        }
      } else {
        return Array.apply(null, { length: nrPages }).map((_, index) => index + 1)
      }
    },
    lastPage: function() {
      return Math.ceil(this.totalItems / this.perPage)
    },
  },
  watch: {
    page: function(newPage) {
      this.currPage = newPage
    },
    itemsPerPage: function(newItemsPerPage) {
      this.perPage = newItemsPerPage
      this.checkCurrentPageExist()
    },
  },
  methods: {
    pageClass: function(currentPage) {
      return this.currPage === currentPage ? `${this.css.paginationItem} selected` : this.css.paginationItem
    },
    changePage: function(pageToMove) {
      if (pageToMove <= this.lastPage && pageToMove >= 1 && pageToMove !== this.currPage) {
        this.$emit('onUpdate', pageToMove)
      }
    },
    isActionDisabled: function(action) {
      if (this.disablePagination) {
        return true
      }
      switch (action) {
        case 'firstPage':
          return this.currPage === 1
        case 'previousPage':
          return this.currPage === 1
        case 'lastPage':
          return (
            this.currPage === this.lastPage ||
            !this.totalItems ||
            this.currPage * this.itemsPerPage >= this.totalItems
          )
        case 'nextPage':
          return (
            this.currPage === this.lastPage ||
            !this.totalItems ||
            this.currPage * this.itemsPerPage >= this.totalItems
          )
      }
    },
    checkCurrentPageExist: function() {
      if (this.qntPages.indexOf(this.currPage) === -1) {
        const nextPage = this.qntPages.length ? this.qntPages.length : 0
        this.$emit('updateCurrentPage', nextPage)
      }
    },
  },
}
</script>
<style scoped src="./custom-grid.css"></style>
